document.addEventListener('bfwt-turnstile-ready', function () {
  const form = document.getElementById('bfwt-contact-form');
  if (!form) return;

  const submitButton = form.querySelector('button[type="submit"]');
  submitButton.disabled = false;
  const apiEndpoint =
    (window.bfwtVars?.restUrl || '/wp-json/') + 'app-api/v1/contact-form';

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    const originalButtonText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = 'Sending...';

    try {
      await window.bfwtTurnstile.ensureToken(form);

      const data = Object.fromEntries(new FormData(form).entries());

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': window.bfwtVars?.nonce || '',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'An unknown error occurred.');
      }

      window.BFWT_Toast?.success(result.message);
      form.reset();
      submitButton.textContent = 'Message Sent!';
      if (typeof window.bfwt_trackEvent === 'function') {
        window.bfwt_trackEvent('contact_form_submit', {
          event_category: 'contact',
        });
      }
      if (window.BFWT_Accessibility)
        {window.BFWT_Accessibility.announce(result.message, 'polite');}
    } catch (error) {
      window.BFWT_Toast?.error(error.message);
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
      window.bfwtTurnstile.reset(form);
      if (window.BFWT_Accessibility)
        {window.BFWT_Accessibility.announce(
          'Error: ' + error.message,
          'assertive'
        );}
    }
  });
});
